export type HelpMeChoosePageProps = {
  header?: string;
  description?: string;
  answers?: React.ReactNode;
};

export const HelpMeChoosePage: React.FC<HelpMeChoosePageProps> = ({
  header,
  description,
  answers,
}) => {
  return (
    <div className="HelpMeChoose__page">
      <h1 className="heading-sm heading-neutral-amplified">{header}</h1>
      <p className="label-moderate label-lg my-snug-lg">{description}</p>
      <div className="flex flex-col lg:flex-row gap-comfy-sm mt-comfy-lg md:mt-roomy-sm justify-center">
        {answers}
      </div>
    </div>
  );
};
